<template>
  <div
    class="relative w-full mx-auto"
    role="document"
  >
    <div class="bg-white rounded-lg shadow-2xl relative w-full border-none">

      <div
        class="!rounded-t-lg bg-[#009A78] text-white 
             text-xl 4xl:text-[28px] 5xl:text-[36px] 
             font-medium p-3 4xl:p-6 5xl:p-8 
             text-start relative"
      >
          {{ mode === "edit" ? "Edit Feeder Pillar" : "Add New Feeder Pillar" }}
      </div>

      <div class="p-6 md:p-10 4xl:p-14 5xl:p-20 flex flex-col gap-5 4xl:gap-7 5xl:gap-10">
        <form autocomplete="off" @submit.prevent class="grid grid-cols-1 md:grid-cols-2 gap-x-4 4xl:gap-x-6 5xl:gap-x-8 gap-y-5 4xl:gap-y-7 5xl:gap-y-10">
          
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="FeederPillarName"
            >
              Feeder Pillar Name
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="FeederPillarName"
              type="text"
              v-model="FeederPillarName"
              autocomplete="new-text"
            />
          </div>
          
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="FeederPillarCode"
            >
              Feeder Pillar Code
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="FeederPillarCode"
              type="text"
              v-model="FeederPillarCode"
              autocomplete="new-text"
            />
          </div>
          
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="FeederPillarToken"
            >
              Feeder Pillar Token
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="FeederPillarToken"
              type="text"
              v-model="FeederPillarToken"
              autocomplete="new-text"
            />
          </div>

          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="Description"
            >
              Feeder Pillar Description
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="Description"
              type="text"
              v-model="Description"
              autocomplete="new-text"
            />
          </div>

          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="commDate"
            >
              Commission Date
            </label>
            <Datepicker
              class="datepicker-custom w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     !rounded-lg bg-[#F0F0F0] text-[#000000] font-normal 
                     text-[16px] 4xl:!text-[22px] 5xl:!text-[30px]"
              id="commDate"
              v-model="commDate"
              :enable-time-picker="false"
              placeholder="Select Comm Date"
            ></Datepicker>
          </div>

          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="StickerName"
            >
              Sticker Name
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="StickerName"
              type="text"
              v-model="StickerName"
              autocomplete="new-text"
            />
          </div>

          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="Latitude"
            >
              Latitude
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="Latitude"
              type="text"
              v-model="Latitude"
              autocomplete="new-text"
            />
          </div>
          
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="Longitude"
            >
              Longitude
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="Longitude"
              type="text"
              v-model="Longitude"
              autocomplete="new-text"
            />
          </div>
          
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="Location"
            >
              Location
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="Location"
              type="text"
              v-model="Location"
              autocomplete="new-text"
            />
          </div>
          
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="StreetName"
            >
              Street Name
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="StreetName"
              type="text"
              v-model="StreetName"
              autocomplete="new-text"
            />
          </div>
          
          <div class="col md:col-span-2">
            <label 
              class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
              for="Status"
            >
              Remark Status
            </label>
            <div class="relative custom-select">
              <select
                id="Status"
                class="form-select w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                       px-3 4xl:px-5 5xl:px-6 
                       !rounded-lg !bg-[#F0F0F0] border-none appearance-none 
                       text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                       text-[#009a78] font-normal !bg-none disabled:opacity-70 disabled:cursor-not-allowed"
                v-model="Status"
              >
                <option
                  v-for="option in Statuses"
                  :key="option.value"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>
        </form>
      </div>

      <div
        class="p-6 md:p-10 4xl:p-14 5xl:p-20 
             flex flex-col gap-5 4xl:gap-7 5xl:gap-9 
             border-t border-gray-200 !rounded-b-lg"
      >
        <button
          class="w-full h-[51px] 4xl:!h-[72px] 5xl:!h-[104px] 
                 !rounded-lg 5xl:!rounded-2xl bg-[#009A78] text-white 
                 text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                 font-normal hover:bg-[#00795e] transition duration-200"
          type="button"
          @click="handleSave"
        >
          Save
        </button>
        
        <button
          v-show="mode === 'edit'"
          class="w-full h-[51px] 4xl:!h-[72px] 5xl:!h-[104px] 
                 !rounded-lg 5xl:!rounded-2xl bg-[#FF9700] text-white 
                 text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                 font-normal hover:bg-[#cc7a00] transition duration-200"
          type="button"
          @click="handleDelete"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";

export default {
  components: {
    Datepicker,
  },
  props: ["isEdit", "formEdit"],
  watch: {
    isEdit: {
      handler: function (val) {
        this.mode = val ? "edit" : "add";
        this.FeederPillarID = val ? this.formEdit.FeederPillarID : "";
        this.FeederPillarName = val ? this.formEdit.FeederPillarName : "";
        this.FeederPillarCode = val ? this.formEdit.FeederPillarCode : "";
        this.FeederPillarToken = val ? this.formEdit.FeederPillarToken : "";
        this.Description = val ? this.formEdit.Description : "";
        this.commDate = val ? this.formEdit.CommDate : "";
        this.StickerName = val ? this.formEdit.StickerName : "";

        this.Latitude = val ? this.formEdit.Latitude : "";
        this.Longitude = val ? this.formEdit.Longitude : "";
        this.Location = val ? this.formEdit.Location : "";
        this.StreetName = val ? this.formEdit.StreetName : "";
        this.Status = val ? this.formEdit.Status : "";
      },
      deep: true,
      immediate: true,
    },
    formEdit(val) {
      this.mode = this.isEdit ? "edit" : "add";
      this.FeederPillarID = val.FeederPillarID;
      this.FeederPillarName = val.FeederPillarName;
      this.FeederPillarCode = val.FeederPillarCode;
      this.FeederPillarToken = val.FeederPillarToken;
      this.Description = val.Description;
      this.commDate = val.CommDate;
      this.StickerName = val.StickerName;
      this.Latitude = val.Latitude;
      this.Longitude = val.Longitude;
      this.Location = val.Location;
      this.StreetName = val.StreetName;
      this.Status = val.Status;
    },
  },
  data() {
    return {
      mode: "add",
      connectionType: "LoraWAN",
      FeederPillarID: "",
      FeederPillarName: "",
      FeederPillarCode: "",
      FeederPillarToken: "",
      Description: "",
      commDate: "",
      StickerName: "",
      DeviceToken: "",
      ElectricityTariff: "",
      ApplicationKey: "",
      Latitude: "",
      Longitude: "",
      Location: "",
      StreetName: "",
      Status: "",
      Statuses: [
        {
          label: "Active",
          value: "active",
        },
        {
          label: "Disabled",
          value: "disabled",
        },
      ],
      connectionTypeOptions: ["LoraWAN", "Cellular", "No Connectivity"],
    };
  },
  emits: ["closeModal", "onDelete", "onSave"],
  methods: {
    getConnectionType() {
      this.connectionTypeOptions = [];
      this.$http.get(":11005/api/v1/conntype").then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].conntypename,
              value: response[i].conntypeid,
            };
            this.connectionTypeOptions.push(obj);
          }
        }
      });
    },
    handleSelectedType(option) {
      this.connectionType = option;
    },
    closeModal() {
      this.resetForm();
      this.$emit("closeModal");
    },
    handleSave() {
      this.$emit(
        "onSave",
        this.isEdit
          ? {
              FpName: this.FeederPillarName,
              FpCode: this.FeederPillarCode,
              FpToken: this.FeederPillarToken,
              FpDesc: this.Description,
              CommDate: moment(this.commDate).format("YYYY-MM-DD"),
              Latitude: parseFloat(this.Latitude),
              Longitude: parseFloat(this.Longitude),
              StickerName: this.StickerName,
              Location: this.Location,
              StreetName: this.StreetName,
              RemarkStatus: this.Status,
            }
          : {
              FP: [
                {
                  FpName: this.FeederPillarName,
                  FpCode: this.FeederPillarCode,
                  FpToken: this.FeederPillarToken,
                  FpDesc: this.Description,
                  CommDate: moment(this.commDate).format("YYYY-MM-DD"),
                  Latitude: parseFloat(this.Latitude),
                  Longitude: parseFloat(this.Longitude),
                  StickerName: this.StickerName,
                  Location: this.Location,
                  StreetName: this.StreetName,
                  RemarkStatus: this.Status,
                },
              ],
            },
        this.isEdit ? this.FeederPillarID : ""
      );
      this.resetForm();
    },
    handleDelete() {
      this.$emit("onDelete", this.FeederPillarID);
      this.resetForm();
    },
    resetForm() {
      this.FeederPillarID = "";
      this.FeederPillarName = "";
      this.Description = "";
      this.FeederPillarCode = "";
      this.FeederPillarToken = "";
      this.commDate = "";
      this.StickerName = "";
      this.Location = "";
      this.StreetName = "";
      this.Latitude = "";
      this.Longitude = "";
      this.Status = "";
    },
  },
  mounted() {
    console.log("masuk subi")
    this.getConnectionType();
  },
};
</script>

<style lang="scss" scoped>
// Inherit/replicate the styles from the holidays modal for consistency
.custom-select::after {
  content: "▼";
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #009a78; 
  font-size: 16px; /* Default size */
}

// Global datepicker styling to match the holidays modal input field look
.datepicker-custom {
  .dp__input_wrap {
    height: 100%;
  }
  .dp__input {
    height: 100%;
    border: none;
    border-radius: 8px;
    background: #f0f0f0;
    color: #000000 !important;
    font-weight: 400 !important;
    font-size: 16px;
    padding: 0.75rem 1rem; /* Adjusted for better alignment */
    font-family: inherit;
    &::placeholder {
      color: #9b9a9a !important;
      font-weight: 400 !important;
    }
  }
  .dp__input:focus {
    box-shadow: 0 0 0 1px #3b82f6 !important;
    border-color: #3b82f6 !important;
    outline: none;
  }
}

// Responsive Styles (Replicated from Holidays Modal CSS)
@media (min-width: 2560px) {
  .custom-select::after {
    font-size: 22px; 
    right: 1.5rem;
  }
  .datepicker-custom {
    .dp__input {
      font-size: 22px !important;
      padding: 1.2rem 1.5rem !important; 
    }
  }
}

@media (min-width: 3840px) {
  .custom-select::after {
    font-size: 30px; 
    right: 2rem;
  }
  .datepicker-custom {
    .dp__input {
      font-size: 30px !important;
      padding: 1.8rem 2rem !important; 
    }
  }
}
</style>